import brFlag from '../../assets/icons/languages/br.svg'
import deFlag from '../../assets/icons/languages/de.svg'
import enFlag from '../../assets/icons/languages/en.svg'
import esFlag from '../../assets/icons/languages/es.svg'
import frFlag from '../../assets/icons/languages/fr.svg'
import trFlag from '../../assets/icons/languages/tr.svg'
import ptFlag from '../../assets/icons/languages/pt.svg'
import rsFlag from '../../assets/icons/languages/rs.svg'
import itFlag from '../../assets/icons/languages/it.svg'
import czFlag from '../../assets/icons/languages/cz.svg'

export const languages = [
	{
		code: 'en',
		label: 'English',
		icon: enFlag,
		locale: 'en-us'
	},
	{
		code: 'fr',
		label: 'Français',
		icon: frFlag,
		locale: 'fr'
	},
	{
		code: 'de',
		label: 'Deutsch',
		icon: deFlag,
		locale: 'de'
	},
	{
		code: 'pt',
		label: 'Português',
		icon: ptFlag,
		locale: 'pt'
	},
	{
		code: 'it',
		label: 'Italiano',
		icon: itFlag,
		locale: 'it'
	},
	{
		code: 'es',
		label: 'Español',
		icon: esFlag,
		locale: 'es'
	},
	{
		code: 'cz',
		label: 'Czech Republic',
		icon: czFlag,
		locale: 'cy'
	},
	{
		code: 'nl',
		label: 'Nederlands',
		locale: 'nl'
	},
	{
		code: 'zh',
		label: '中文(简体)',
		locale: 'zh-cn'
	},
	{
		code: 'zh-hans',
		label: '中文(简体)',
		locale: 'zh-cn'
	},
	{
		code: 'ja',
		label: '日本語',
		locale: 'ja'
	},
	{
		code: 'pl',
		label: 'Polski',
		locale: 'pl'
	},
	{
		code: 'pt-BR',
		label: 'Português do Brasil',
		icon: brFlag,
		locale: 'pt-br'
	},
	{
		code: 'ru',
		label: 'РУССКИЙ',
		locale: 'ru'
	},
	{
		code: 'id',
		label: 'Bahasa Indonesia',
		locale: 'id'
	},
	{
		code: 'ko',
		label: '한국어',
		locale: 'ko'
	},
	{
		code: 'tr',
		label: 'Türkçe',
		icon: trFlag,
		locale: 'tr'
	},
	{
		code: 'ar',
		label: 'العربية',
		locale: 'ar'
	},
	{
		code: 'th',
		label: 'ไทย',
		locale: 'th'
	},
	{
		code: 'sv',
		label: 'Svenska',
		locale: 'sv'
	},
	{
		code: 'rs',
		label: 'Serbia',
		icon: rsFlag,
		locale: 'sr'
	}
]


// WEBPACK FOOTER //
// ./src/utilities/content/supportedLanguages.js